const S3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

export const munCommitteeData = [
  {
    CommitteesName: "UNITED NATIONS HUMAN RIGHTS COUNCIL",
    ChairLabel: "Chair",
    DeputyLabel: "Deputy",
    Chair: "Mr. DHRUVRAJSINH JHALA",
    Deputy: "Mr. DWEEP KHIMANI",
    image: `${S3_url}/NCSR/public/Images/ncs_mun_UNHRC.JPG`,
    message:
      "The United Nations Human Rights Council serves as the conscience of the international community, where delegates uphold fundamental freedoms, address violations, and work collectively to protect the rights and dignity of people across the world.",
    quote: "Human rights at the centre of global responsibility.",
    agenda:
      "Ensuring the Protection of Human Rights in the Era of Deepfakes and AI-Generated Misinformation",
    agendaText:
      "The Human Rights Council will examine how deepfakes and AI-driven misinformation threaten privacy, free expression, reputation, and democratic processes. Delegates should propose safeguards that defend human rights while allowing responsible technological progress.",
  },
  {
    CommitteesName: "UNITED NATIONS SECURITY COUNCIL",
    ChairLabel: "Chair",
    DeputyLabel: "Deputy",
    Chair: "Mr. ADITYARAJSINH CHUDASAMA",
    Deputy: "Ms. AASHI PUJARA",
    image: `${S3_url}/NCSR/public/Images/ncs_mun_UNSC.JPG`,
    message:
      "The United Nations Security Council is not merely a chamber of debate; it is the arena where global crises are confronted, alliances are forged, international tensions are addressed, and the fate of world peace hangs in the balance.",
    quote: "Deliberation for peace, action for stability.",
    agenda:
      "The U.S.-China Strategic Rivalry in the Indo-Pacific: Taiwan Strait, South China Sea, and Regional Stability",
    agendaText:
      "Rising tensions around the Taiwan Strait and disputes in the South China Sea threaten regional stability, trade, and global security. Delegates of the Security Council should develop diplomatic measures to prevent escalation, manage military rivalries, and promote cooperative solutions that preserve peace.",
  },
  {
    CommitteesName: "LOK SABHA",
    ChairLabel: "Speaker",
    DeputyLabel: "Deputy Speaker",
    Chair: "Mr. ARYA MEHTA",
    Deputy: "Ms. HITESHREE NAIDU",
    image: `${S3_url}/NCSR/public/Images/ncs_mun_lokSabha.JPG`,
    message:
      "The Lok Sabha embodies the heart of India's democratic process. Members debate national issues, draft policies, and engage in spirited parliamentary discourse, reflecting the complexities and dynamism of the world's largest democracy.",
    quote: "Where every voice seeks to shape a nation of billions.",
    agenda:
      "Assessing India's Economic and Energy Security Amid Escalating Global Trade Wars, Rising Tariff Barriers, and Dependence on Middle Eastern Oil",
    agendaText:
      "Geopolitical shifts and tariff barriers are placing pressure on India's economic stability and access to energy supplies. Members of the Lok Sabha will explore diversification of suppliers and partnerships, strategies to strengthen domestic industry and energy resilience, and policy measures that protect long-term national interests.",
  },
  {
    CommitteesName: "GUJARAT LEGISLATIVE ASSEMBLY",
    ChairLabel: "Speaker",
    DeputyLabel: "Deputy Speaker",
    Chair: "Ms. HETVI KARIA",
    Deputy: "Mr. SHYAM DATANI",
    image: `${S3_url}/NCSR/public/Images/ncs_mun_GLA.JPG`,
    message:
      "The Gujarat Legislative Assembly provides a platform to address the opportunities and challenges shaping one of India's most progressive states. Delegates examine and discuss regional governance, public welfare, and state policy while navigating the realities of contemporary politics.",
    quote: "Driving progress through local leadership.",
    agenda:
      "Aligning Industrial Growth with Employment and Skill Development Opportunities for Gujarat’s Youth",
    agendaText:
      "Rapid industrial expansion in the state risks outpacing the skills and employment opportunities available to Gujarat’s youth. Members of the Gujarat Legislative Assembly will propose policies linking industry growth with vocational training, apprenticeships, and job-creation strategies to ensure sustainable development and meaningful careers for young people.",
  },
  {
    CommitteesName: "INTERNATIONAL PRESS",
    ChairLabel: "IP Head",
    DeputyLabel: "",
    Chair: "",
    Deputy: "",
    image: `${S3_url}/NCSR/public/Images/ncs_mun_Press.jpeg`,
    message:
      "Armed not with votes but with the power of the pen, the International Press stands as the conference's watchful eye. Every statement, every alliance, and every controversy finds its way into the headlines they create.",
    quote: "The delegates make history. The press decides how it is remembered.",
    agenda:
      "Upholding the Principles of Journalism in the Era of Global Change",
    agendaText:
      "In an age of rapid technological advancement and instant communication, the role of journalism remains vital. As members of the International Press, journalists and photographers will be tasked with documenting committee proceedings, conducting interviews, capturing key moments, and producing accurate, engaging reports. Through responsible reporting and creative storytelling, they will bring the conference to life.",
  },
];

export const munTestimonialData = {
  title: "NCS MUN",
  message:
    "“Human rights at the centre of global responsibility.” “Deliberation for peace, action for stability.” “Where every voice seeks to shape a nation of billions.” “Driving progress through local leadership.” “The delegates make history. The press decides how it is remembered.”",
  agenda:
    "NCS MUN is more than a simulation. It is a learning experience that nurtures awareness, empathy, and responsible leadership.",
};
